<template>
  <div>
    <div class="page_title">开方指南</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div>
          <el-button
            type="primary"
            icon="el-icon-edit"
            @click="Add"
            v-if="edit"
          >编辑开方指南</el-button>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="Add"
            v-else
          >添加开方指南</el-button>
        </div>
        <div
          class="essaybox"
          v-if="edit"
        >
          <div class="title">{{detail.title}}</div>
          <div v-html="detail.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import imgtext from '../../../api/imgtext';
export default {
  data() {
    return {
      detail: {},
      edit: false
    };
  },

  methods: {
    //获取图文信息
    getDetail() {
      let art_id = 9;
      imgtext.getArticleInfo({ art_id }).then((res) => {
        if (res.code == 0) {
          this.detail = res.data.info;
          if (this.detail.content) {
            this.edit = true;
            this.detail.content = this.detail.content.replace(
              /<img/g,
              "<img style='width:100%'"
            );
            this.detail.content = this.detail.content.replace(
              /<video/g,
              "<video style='width:100%'"
            );
          }
        }
      });
    },

    //添加文章
    Add() {
      this.$router.push('addprescription');
    },
    //编辑项目(基本信息维护)
    editBuild(pro_id) {
      this.$router.push({ path: 'builddetail', query: { pro_id: pro_id } });
    },
    //删除文章
    delEssay(id) {
      this.$confirm('您确定删除该文章吗？', '删除提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          imgtext
            .delEssay({ id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('删除成功');
                if (!(this.tableData.length - 1) % this.pagesize) {
                  this.currentPage =
                    this.currentPage == 1 ? 1 : this.currentPage - 1;
                }
                this.getEssay();
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    //发布文章
    submit(id) {
      this.$confirm('您确定要发布该文章吗？', '提示消息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          imgtext
            .formalEssay({ id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('发布成功');
                this.getEssay();
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },

    //排序
    updateSort(id, sort) {
      imgtext.editEssaySort({ id, sort }).then((res) => {
        if (res.code == 0) {
          this.getEssay();
        } else {
          this.$message.error(res.message);
        }
      });
    }
  },
  created() {
    this.getDetail();
  }
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
  text-align: left;
}
.essaybox {
  width: 70%;
  padding: 30px 50px;
  box-sizing: border-box;
  border: solid 2px #cfcece;
  margin: 20px auto 0;
  text-align: left;
  min-height: calc(100vh - 240px);

  .title {
    font-size: 18px;
    font-weight: 700;
  }
  .date {
    font-size: 12px;
    color: #737373;
    margin: 10px 0 30px;
  }
}
</style>

